import React from 'react'
import emoji from 'react-easy-emoji'
import { emojify } from 'node-emoji'
import { isEmpty, has, flatten } from 'lodash'
import replaceStringToArray from 'string-replace-to-array'
// making sure store changes propagate to render before trying to set focus
export const focus = ref => setTimeout(() => ref.current?.focus(), 100)

export const image = profile => CONFIG.features.useCats ?
  `https://robohash.org/${profile.username}${profile.birthday}?size=100x100&bgset=bg1&set=set4` :
  safeModeEnabled() && profile.profileImageNsfw ? profile.profileImageNsfw : profile.profileImage

export const getNudeCover = () => {
  let cleanedHost = location.host.replace('www.','')
  cleanedHost = cleanedHost.replace('staging.', '') // this is needed for staging since no images on staging dating sites
  return location.protocol + '//images.' + cleanedHost + '/internal/no_photo_safe_woman.png'
}


export const safeModeEnabled = () => [1, '1', true, 'true'].includes(CONFIG.safeMode)

export const calculateScrollbarSize = () => {
  const temp = document.createElement('div')
  Object.assign(temp.style, {
    overflow: 'scroll',
    position: 'absolute',
    visibility: 'hidden',
  })
  document.body.appendChild(temp)
  const size = temp.offsetHeight
  setTimeout(() => document.body.removeChild(temp), 0)
  return size
}

export const getYoutubeId = url => {
  const regExp = /.*(?:youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=)([^#\&\?]*).*/
  const match = url.match(regExp)
  return (match && match[1].length == 11) ? match[1] : false
}

//TM Legacy emoji - https://bitbucket.org/strcdrs/dating/src/master/protected/helpers/UIHelper.php
const commonEmoji = [
  { value: '😇', regex: /O:\)/ig }, //tm
  { value: '🙂', regex: /:-?\)|:simple_smile:/ig },
  { value: '🙁', regex: /:-?\(/ig },
  { value: '😄', regex: /:-?D\b/ig },
  { value: '😉', regex: /;-?\)/ig },
  { value: '😛', regex: /:-?P\b/ig },
  { value: '😮', regex: /:-?o\b/ig },
  { value: '❤️', regex: /<3|\(heart\)/ig },
  { value: '😎', regex: /8\)/ig }, //tm
  { value: '😳', regex: /\(embarrassed\)/ig }, //tm
  { value: '🤭', regex: /\(oops\)/ig }, //tm
  { value: '☠️', regex: /\(pirate\)/ig }, //tm
  { value: '👎', regex: /\(thumbsdown\)/ig }, //tm
  { value: '👍', regex: /\(thumbsup\)/ig }, //tm
  { value: '😬', regex: /:#/ig }, //tm
  { value: '🤑', regex: /:\$/ig }, //tm
  { value: '😭', regex: /:'\(/ig }, //tm
  { value: '😚', regex: /:-\*/ig }, //tm
  { value: '🤐', regex: /:Z/ig }, //tm
  { value: '😕', regex: /:\\/ig }, //tm
  { value: '😐', regex: /:\|/ig }, //tm
]

const fallbackEmojis = text => {
  const content = Array.isArray(text) ? text : [text]

  return flatten(content.map(item => {
    if (typeof item === 'string' && /\(ninja\)/ig.test(item)) {
      return replaceStringToArray(item, /\(ninja\)/ig, (match, _, offset) => (
        <img
          alt="🥷"
          key={offset}
          draggable="false"
          src="https://twemoji.maxcdn.com/2/72x72/1f977.png"
          style={{ height: '1em', width: '1em', margin: '0px 0.05em 0px 0.1em', verticalAlign: '-0.1em' }}
        />
      ))
    }
    return item
  }))
}

export const addEmoji = (text, options={}) => {
  commonEmoji.forEach(({value, regex}) => {
    text = text.replace(regex, value)
  })
  text = emojify(text)
  return fallbackEmojis(options.useImages ? emoji(text) : text)
}

export const getStickerUrl = (id, format='svg') => {
  if (id.match(/cat_/)) {
    return `https://cdn2.thecatapi.com/images/${id.slice(4)}${id.includes('.') ? '' : '.jpg'}`
  }
  if (CONFIG.urls.sticker) {
    return CONFIG.urls.sticker(id, format)
  }
  try {
    return require(`../assets/stickers/${format}/${id}.${format}`)
  } catch (e) {
    return `/images/stickers/${format}/${id}.${format}`
  }
}

export const addStickers = text => {
  const [, id] = text.match(/:sticker-([^:]+?):/) || []
  return !!id && <img className="sticker" alt={text} src={getStickerUrl(id, 'png')} height="150"/>
}

export const isDeleted = conv => conv && conv.error && conv.error.code === 'conversationDeleted'

export const isCorrupt = conv => {
  const corrupt = ['me', 'otherUser', 'user0', 'user1'].filter(f =>
    has(conv, f + 'Profile') && isEmpty(conv[f + 'Profile']) && conv[f + 'Uid'] != CONFIG.userUid
  )
  corrupt.forEach(f => console.warn(`User ${conv[f + 'Uid']} not found (might be deleted)`))
  return corrupt.length
}

export const byId = x => {
  const id = x && x.conversationUid || x
  return c => c.conversationUid == id
}

export const avatarBackground = username => {
  let hash = 0
  username.split('').forEach((c,i) => {
    hash = username.charCodeAt(i) + (hash << 5 - hash)
  })
  return `hsl(${hash % 360},45%,60%)`
}

export const rgba = (color, opacity = 1) => {
	let c = [0, 0, 0, opacity]
	if (/^#[a-f0-9]{3,6}$/i.test(color)) {
		c = color.slice(1)
		c = '0x' + (c.length < 6 ? [c[0], c[0], c[1], c[1], c[2], c[2]].join('') : c)
		c = [(c >> 16) & 255, (c >> 8) & 255, c & 255, opacity]
	}
	const m = color.replace(/ /g, '').match(/^rgba?\((\d+),(\d+),(\d+)(?:,([\d\.]+))?\)/i)
	if (m) {
		c = [m[1], m[2], m[3], (m[4] || 1) * opacity]
	}
	return `rgba(${c.join(', ')})`
}

export const isAndroidDevice = () =>  {
  return /Android/i.test(navigator.userAgent);
}